module.exports = __webpack_public_path__ + "static/media/48239702_2308779505863894_1001542508926205952_o-thumb.4acd9966.jpg";